/**
 * Super View / User View switch — owner only.
 *
 * Rendered on `useIsOwner` rather than `useIsOwnerView`, deliberately: the
 * control must stay visible once User View is on, or switching would be a
 * one-way door and the owner would have to clear storage to get their own
 * dashboard back.
 */
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

import { useIsOwner } from "@/components/shared/RequireSuperAdmin";
import { useViewModeStore } from "@/store/viewModeStore";

export function ViewModeToggle() {
  const isOwner = useIsOwner();
  const mode = useViewModeStore((s) => s.mode);
  const toggle = useViewModeStore((s) => s.toggle);

  if (!isOwner) return null;

  const isSuper = mode === "super";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={!isSuper}
      title={
        isSuper
          ? "Switch to User View — hides owner-only sections so you see the dashboard as other admins do"
          : "Return to Super View"
      }
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium transition ${
        isSuper
          ? "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
          : "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100"
      }`}
    >
      {isSuper ? (
        <EyeIcon className="h-3.5 w-3.5" aria-hidden />
      ) : (
        <EyeSlashIcon className="h-3.5 w-3.5" aria-hidden />
      )}
      {isSuper ? "Super View" : "User View"}
    </button>
  );
}
